import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Style from 'style-it'

import { styles } from './styles';
import {styles as hoverStyle} from '../shared/styles'
import {TimeProcessing} from '../shared/icons';
import { colors } from '../../shared/styles';
import {getResultsUrl} from '../../utils/resultsHelpers';

class PendingResults extends Component {
  static propTypes = {
    currentEvent: PropTypes.object,
    races: PropTypes.array,
    t: PropTypes.func,
  };

  static defaultProps = {
    currentEvent: {},
    races: []
  };

  state = {
    showingAll: false
  };

  getOtherDates = () => {
    const {currentEvent, races, history, t} = this.props;
    const {showingAll} = this.state;

    if (!currentEvent.event || !currentEvent.event.athlinksId) {
      return null;
    }

    const racesNotCurrent = races.filter((event) => event.value !== currentEvent.event.athlinksId);
    const showAllCondition = showingAll || racesNotCurrent.length <= 3;
    const racesToChooseFrom = showAllCondition ? racesNotCurrent : racesNotCurrent.slice(0,3);

    if(!racesToChooseFrom.length) {
      return null;
    }

    return (
      <div>
        <div style={styles.otherDateButtonContainer}>
          <div style={styles.lookingForMoreText}>
            {t('Looking for other results from this event?')}
          </div>
          {
            racesToChooseFrom.map((event) =>
              <Style key={event.value}>
                {
                  hoverStyle.addResultsHover()
                }
                <button
                  className="hover-add-results-button"
                  onClick={() => history.push({
                    pathname: getResultsUrl(
                      currentEvent.event.masterId,
                      event.value,
                      undefined,
                      undefined,
                      undefined)}
                  )}
                  style={styles.otherDateButton}
                >
                  <div style={styles.otherDateButtonText}>
                    {event.text.toUpperCase()}
                  </div>
                </button>
              </Style>
            )
          }
        </div>
        <div style={styles.otherDateButtonContainer}>
          {
            !showAllCondition &&
            <button
              onClick={() => this.setState({showingAll: true})}
              style={styles.showAllText}
            >
              {t('Show All...')}
            </button>
          }
        </div>
      </div>
    )
  };

  render() {
    const {t} = this.props;

    return (
      <div style={styles.container}>
        <TimeProcessing width={70} fill={colors.grey} style={{fontWeight: 'bold'}}/>
        <div style={styles.processingText}>{t('Processing Results')}</div>
        <div style={styles.processingSubText}>{t('We’re working on adding the results for this event and they will be available ASAP.')}</div>
        <div style={styles.processingSubText}>{t('Please check back soon!')}</div>
        {this.getOtherDates()}
     </div>
    );
  }
}

export const PendingResultsMessage = withTranslation()(withRouter(PendingResults));



/** WEBPACK FOOTER **
 ** ./components/pendingResultsMessage/PendingResultsMessage.js
 **/